import {
  authenticationEndpoint,
  virtualAccountsEndpoints,
  payoutsEndpoints,
  accountEndpoints,
  billPaymentEndpoints,
  customerCryptoEndpoints,
} from './apiData';
import type { ApiEndpoint } from '../types/docs.types';

export interface SearchItem {
  id: string;
  title: string;
  description: string;
  method: string;
  url: string;
  section: string;
  path: string;
}

const toItems = (endpoints: ApiEndpoint | ApiEndpoint[], section: string, path: string): SearchItem[] => {
  const arr = Array.isArray(endpoints) ? endpoints : [endpoints];
  return arr.map(ep => ({
    id: ep.id,
    title: ep.title,
    description: ep.description,
    method: ep.method,
    url: ep.url,
    section,
    path,
  }));
};

export const searchIndex: SearchItem[] = [
  ...toItems(authenticationEndpoint, 'Authentication', '/authentication'),
  ...toItems(virtualAccountsEndpoints, 'Collections', '/collections'),
  ...toItems(payoutsEndpoints, 'Payouts', '/payouts'),
  ...toItems(accountEndpoints, 'Account Management', '/account'),
  ...toItems(billPaymentEndpoints, 'Bill Payment', '/bill-payment'),
  ...toItems(customerCryptoEndpoints, 'Customer (Crypto)', '/customer-crypto'),
];
